
import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
import { FormsModule } from '@angular/forms';

declare var $;


@Component({
    selector: 'app-proofing-types',
    templateUrl: './proofing-types.component.html',
    styleUrls: ['./proofing-types.component.css']
})


/** ProofingTypes component*/
export class ProofingTypesComponent {
  showModal: boolean;
  title: string;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;
  isDisabled: boolean;// to enable/disable proofingtext box
  isHiddenAdd: boolean;
  isHiddenupdate: boolean;// hide/dsplay the Add button

    /** ProofingTypes ctor */
  constructor() {

    localStorage.aEID = 0;
    this.isDisabled = true;//proofingtxtbox
    this.isHiddenAdd = true;
    this.isHiddenupdate = false

  }
  ngOnInit(): void {
    this.getProofingtypList();
  }

  //datgrid load fn 
  getProofingtypList(): void {
    $("#LoadingImage").show();
    let nPublisherId = localStorage.aPubID;
    ApiMethod.getMethod('gen/proofing-typeList/' + localStorage.aLoginID + '/' + nPublisherId).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aProofingTypeList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'ProofingTypeModule';
        dataItem.rowSelect = true;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
   /*     $('#tblproofing').DataTable();*/

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }


  //Delete a record
  Delete() {
    ngswal({
      title: "Are you sure to delete ProofingType?",
      //text: "ProofingType is deleted permanently !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel! :)", "warning");
        }
      });
  }
  //delete a proofing type from grid after confirmation
  DeleteConfirm() {

    $('#LoadingImage').show();  
   //api call to delete a record
    ApiMethod.postMethod("gen/DeleteProofingType/" + localStorage.aEID + '/' + localStorage.aLoginID,"").subscribe(
      result => {
        $("#LoadingImage").hide();
        this.getProofingtypList();//refresh the grid
        this.hide();


        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted !",
          text: result ,
          showConfirmButton: false,
          timer: 1500
        });
        this.getProofingtypList();

      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );

      
  }
  //clear the data
  clearData(): void {
    let form: NgForm = $('form#frmproofing');
    form[0].reset();

  }

  //Show ProofingType control popup
  show(): void {
    this.clearData();
    if (localStorage.aEID != 0) {

      $("#LoadingImage").show();
      // api call to get the record based on ID
      ApiMethod.getMethod('gen/proofing-typeById/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();

          let itemL = result.aProofTypeitem;
          $('#txtproofingtyp').val(itemL.ProofingType);
          $('#txtMailbdyft').val(itemL.MailBodyFormat);
          $('#txtDMailbdyft').val(itemL.DefaultMailBodyFormat);

          this.isDisabled = true;//txtproofing disabled
          this.isHiddenAdd = true;
          this.isHiddenupdate = false;// update shown add hidden

          


        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
    else {

      this.isDisabled = false;//txtproofing disabled
      this.isHiddenAdd = false;// show add
      this.isHiddenupdate = true;// hide update
    }
    this.showModal = true; // Show-Hide Modal Check
    this.title = "ProofingType Details";    // Dynamic Data

  }
  //Bootstrap Modal Close event
  hide() {
    this.clearData();
    this.showModal = false;
  }
  //Update ProofingType details by ID
  updateProofingTypeDetails(): void {
    if ($('#txtproofingtyp').val().trim() == '') {
      ngswal("Warning !", "Enter ProofingType  !", "warning");
    }
    else if ($('#txtMailbdyft').val().trim() == '') {
      ngswal("Warning !", "Enter MailBody Format !", "warning");
    }
    else if ($('#txtDMailbdyft').val().trim() == '') {
      ngswal("Warning !", "Enter DefaultMailBody Format !", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var aProofitemL = {
        ID: localStorage.aEID,
        ProofingType: $('#txtproofingtyp').val(),
        MailBodyFormat: $('#txtMailbdyft').val(),
        DefaultMailBodyFormat: $('#txtDMailbdyft').val(),
        UpdatedBy: localStorage.aLoginID,
      };
      //api call to update the record by ID
      ApiMethod.postMethod('gen/updateproofingtype', aProofitemL).subscribe(
        response => {
          this.getProofingtypList();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response,
            showConfirmButton: false,
            timer: 1500
          });
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );

    }
  }

  //Add ProofingType  method
  AddProofingTypeDetails(): void {
    if ($('#txtproofingtyp').val().trim() == '') {
      ngswal("Warning !", "Enter ProofingType  !", "warning");
    }
    else if ($('#txtMailbdyft').val().trim() == '') {
      ngswal("Warning !", "Enter MailBody Format !", "warning");
    }
    else if ($('#txtDMailbdyft').val().trim() == '') {
      ngswal("Warning !", "Enter DefaultMailBody Format !", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var aProofitemL = {
        ID: localStorage.aEID,
        ProofingType: $('#txtproofingtyp').val(),
        MailBodyFormat: $('#txtMailbdyft').val(),
        DefaultMailBodyFormat: $('#txtDMailbdyft').val(),
        UpdatedBy: localStorage.aLoginID,
      };

      //api call to add a new record
      ApiMethod.postMethod('gen/AddProofingType', aProofitemL).subscribe(
        response => {
          this.getProofingtypList();
          $("#LoadingImagePopup").hide();
          this.hide();
          if (response == 'ProofingType already exist!') {
            ngswal({
              position: 'top-end',
              type: "warning",
              title: "Please Check",
              text: response,
              showConfirmButton: true,
              // timer: 1500
            });
          }
          else {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Success",
              text: response,
              showConfirmButton: true,
              // timer: 1500
            });
          }
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );

    }
  }
}
